import type { ApolloError } from '@apollo/client';
import { useQuery } from '@apollo/client';

import type { GetJobPreferencesIndustriesQuery } from '@xing-com/crate-jobs-graphql';
import { GetJobPreferencesIndustriesDocument } from '@xing-com/crate-jobs-graphql';

type GetJobPreferencesIndustriesResponse = {
  isLoading: boolean;
  data?: GetJobPreferencesIndustriesQuery;
  error?: ApolloError;
};

export const useGetJobPreferencesIndustries =
  (): GetJobPreferencesIndustriesResponse => {
    const { loading, data, error } = useQuery(
      GetJobPreferencesIndustriesDocument,
      {
        errorPolicy: 'all',
      }
    );

    return { isLoading: loading, data, error };
  };
